import * as actionTypes from '../Action/actionTypes';

const initialState = {
  file: []
};

const reducer=(state=initialState,action)=>{
  switch(action.type){

    case actionTypes.File_UPLOADER:
      return {
        ...state,
        file: action.value
      };

    default:
      return state;
  }
};

export default reducer;
